import { useMemo } from 'react';
import { hooks, models } from "@vote4dance/judging-sdk";
var Stream = hooks.streams.Stream;
var RoundPathSource = models.rounds.RoundPathSource;
export const RoundPathParent = ({ children, record }) => {
    const validRoundId = record.isPlaceholder && record.children ? findValidRoundId(record.children) : record.round_id;
    const shouldLoadPath = Boolean(validRoundId && validRoundId !== 'new');
    const roundPathSource = useMemo(() => {
        if (!shouldLoadPath || !validRoundId) {
            return undefined;
        }
        return RoundPathSource(record.competition_id, validRoundId);
    }, [shouldLoadPath, record.competition_id, validRoundId]);
    const [paths, loading] = Stream(roundPathSource);
    const parents = useMemo(() => {
        let newList = (paths && paths.length > 1) ? [...paths] : undefined;
        if (newList && record.isPlaceholder) {
            newList.pop();
        }
        return newList;
    }, [paths, record.isPlaceholder]);
    const round = useMemo(() => {
        const removeCount = record.isPlaceholder ? 2 : 1;
        return (record.isPlaceholder && paths && paths.length > 1) ? paths[paths.length - removeCount] : record;
    }, [paths, record, record.isPlaceholder]);
    return typeof (children) == 'function' ? children(round, parents) : children;
};
const findValidRoundId = (children) => {
    var _a;
    if (!children) {
        return undefined;
    }
    return (_a = findValidRound(children)) === null || _a === void 0 ? void 0 : _a.round_id;
};
export const findValidRound = (children) => {
    if (!children) {
        return undefined;
    }
    for (const child of children) {
        if (child.round_id) {
            return child;
        }
        const validRound = findValidRound(child.children);
        if (validRound) {
            return validRound;
        }
    }
    return undefined;
};
